import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React, { useRef } from 'react'
import { createGlobalStyle } from 'styled-components'

import { CloseButton, ImageContainer, LightboxContainer } from './styles'

interface LightboxProps {
  lightboxImage: string | IGatsbyImageData | null
  setLightboxImage: React.Dispatch<
    React.SetStateAction<string | IGatsbyImageData | null>
  >
}

const HideBodyOverflow = createGlobalStyle`
  body {
    overflow:hidden;
  }
`

const Lightbox = ({ lightboxImage, setLightboxImage }: LightboxProps) => {
  const lightboxRef = useRef<HTMLDivElement>(null)

  const closeLightbox = () => {
    setLightboxImage(null)
  }

  const handleCloseLightbox = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if (event.target === lightboxRef.current) {
      closeLightbox()
    }
  }

  return lightboxImage ? (
    <>
      <HideBodyOverflow />
      <LightboxContainer onClick={handleCloseLightbox} ref={lightboxRef}>
        <ImageContainer>
          {typeof lightboxImage === 'string' ? (
            <img
              alt="Lightbox"
              className="lightbox-image"
              src={lightboxImage}
            />
          ) : (
            <GatsbyImage
              alt="Lightbox"
              className="lightbox-image"
              image={lightboxImage}
              imgStyle={{ objectFit: 'contain' }}
            />
          )}
          <CloseButton onClick={closeLightbox}>&times;</CloseButton>
        </ImageContainer>
      </LightboxContainer>
    </>
  ) : null
}

export default Lightbox
